module.exports = __webpack_public_path__ + "img/coo.6a0b5a86.png";